import React from "react";
import { motion } from "framer-motion";
import { Clock, Receipt, Sparkles, ShieldCheck } from "lucide-react";
import { WHY } from "../data/content";

const ICONS = { Clock, Receipt, Sparkles, ShieldCheck };

const IMG =
  "https://images.pexels.com/photos/7859953/pexels-photo-7859953.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=900";

export default function WhyMe() {
  return (
    <section id="miert-en" className="relative py-24 lg:py-32 bg-slate-950 ss-grain overflow-hidden">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-sky-600/15 blur-[130px]" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <span className="text-xs sm:text-sm uppercase tracking-widest font-bold text-sky-300 bg-white/5 px-3 py-1 rounded-full inline-block mb-4 border border-white/10">
            Miért engem válasszon?
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white">
            Egy szaki, akiben <span className="text-cyan-400">meg lehet bízni.</span>
          </h2>
          <p className="mt-4 text-lg text-slate-300 leading-relaxed">
            Egyéni vállalkozóként közvetlenül velem egyeztethet. Nincs call center, nincs rejtett költség – csak tisztességes, igényes munka.
          </p>

          <div className="mt-10 grid sm:grid-cols-2 gap-4">
            {WHY.map((w, i) => {
              const Icon = ICONS[w.icon];
              return (
                <motion.div
                  key={w.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  className="rounded-2xl border border-white/10 bg-white/[0.03] backdrop-blur p-5 hover:bg-white/[0.06] transition-colors"
                >
                  <div className="w-11 h-11 rounded-xl bg-sky-500/15 flex items-center justify-center mb-3">
                    <Icon className="w-5 h-5 text-cyan-400" />
                  </div>
                  <h3 className="font-display font-bold text-white text-lg mb-1">{w.title}</h3>
                  <p className="text-sm text-slate-400 leading-relaxed">{w.desc}</p>
                </motion.div>
              );
            })}
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="relative"
        >
          <div className="rounded-[28px] overflow-hidden border border-white/10 shadow-2xl">
            <img src={IMG} alt="Fűtésrendszer szerelés" className="w-full h-[520px] object-cover" />
          </div>
          <div className="absolute -top-5 -right-3 bg-cyan-500 text-slate-950 rounded-2xl px-5 py-4 shadow-xl">
            <div className="font-display font-extrabold text-3xl leading-none">15+</div>
            <div className="text-xs font-bold mt-1">év a szakmában</div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
